import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {
    Row,
    Form,
    Icon,
    Input,
    Divider,
    Descriptions,
    Collapse,
    Select,
    InputNumber, Checkbox
} from 'antd';
import {RTLCol, RTLButton, RTLModal, RTLTable} from '../RTLKit';
import _ from 'lodash'

/* ------ Field -------- */
import TextArea from '../formFields/TextAreaField';
import DescriptionList from '../formFields/DescriptionList';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import Loading from "../loading/loading";
import moment from "jalali-moment";
import TextField from "../formFields/TextField";
import Alert from "antd/es/alert";

class TechForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            orderId: this.props.match.params.orderId ? this.props.match.params.orderId : null,
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            formLayout: 'horizontal',
            cheque:[],
            cash:0,
            pos:0,
            chequeNum:[],
            amount:0,
            amount1:0,
            amount2:0,
            amount3:0,
            amount4:0,
            amount5:0,
            cheque_number:'',
            bank_name:''
        };
        this.props.setOrderId(this.state.orderId);

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        if (this.props.match.params.orderId) {
            let orderId = this.props.match.params.orderId;
            this.props.getOrderItem(orderId)
        }
    }

    chequeValue(val,i){
        let amount;
        if(i === 0)
            amount = this.state.amount1
        else if(i === 1)
            amount = this.state.amount2
        else if(i === 2)
            amount = this.state.amount3
        else if(i === 3)
            amount = this.state.amount4
        else if(i === 4)
            amount = this.state.amount5
        this.state.cheque.splice(i, 1, {
            bank_name: this.state.bank_name,
            cheque_number: this.state.cheque_number,
            amount: amount,
        })
    }

    changeAmount(val,i){
        if(i === 0)
            this.setState({amount1:val.target.value ? parseInt(val.target.value) : 0})
        else if(i === 1)
            this.setState({amount2:val.target.value ? parseInt(val.target.value) : 0})
        else if(i === 2)
            this.setState({amount3:val.target.value ? parseInt(val.target.value) : 0})
        else if(i === 3)
            this.setState({amount4:val.target.value ? parseInt(val.target.value) : 0})
        else if(i === 4)
            this.setState({amount5:val.target.value ? parseInt(val.target.value) : 0})
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        let date = '';
        let time = '';
        let fullName = '';
        let orderType = '';

        var chequeAmount = parseInt(this.state.amount1)+parseInt(this.state.amount2)+parseInt(this.state.amount3)+parseInt(this.state.amount4)+parseInt(this.state.amount5)
        var totalAmount = parseInt(this.state.cash)+parseInt(this.state.pos)+parseInt(chequeAmount)
        if(this.props.initialValues) {
            orderType = (this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'خدمات');
            date = moment(this.props.initialValues.order.schedule_time).format('jYYYY/jM/jD')
            time = this.props.initialValues.order.schedule_hour
            this.props.initialValues.mode = this.state.mode
            fullName = this.props.initialValues.order.customer_by.name+' '+this.props.initialValues.order.customer_by.family
            if(!_.isEmpty(this.state.cheque))
                this.props.initialValues.cheque = this.state.cheque
        }

        let chequeField = [];
        for(let i=0;i<5;i++){
            chequeField.push(<RTLCol md={24}>
                <RTLCol md={7}>
                    <Field
                        name={'bank_name'+[i]}
                        component={TextField}
                        type="text"
                        placeholder={'نام بانک'}
                        onChange={(val) => this.setState({bank_name : val.target.value})}
                        onBlur={(val) => this.chequeValue(val,i)}
                    />
                </RTLCol>
                <RTLCol md={7}>
                    <Field
                        name={'amount'+[i]}
                        component={TextField}
                        type="text"
                        placeholder={'مبلغ به ریال'}
                        onChange={(val) => this.changeAmount(val,i)}
                        onBlur={(val) => this.chequeValue(val,i)}
                    />
                </RTLCol>
                <RTLCol md={7}>
                    <Field
                        name={'cheque_number'+[i]}
                        component={TextField}
                        type="text"
                        placeholder={'شماره چک'}
                        onChange={(val) => this.setState({cheque_number: parseInt(val.target.value)})}
                        onBlur={(val) => this.chequeValue(val,i)}
                    />
                </RTLCol>
            </RTLCol>)
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">پرداخت فاکتور</Divider>
                </Row>

                {this.props.initialValues ?
                    <Row type="flex" justify="start" align="middle">
                        <RTLCol md={18} sm={24} type="flex" justify="start" align="middle">
                            <Row gutter={16}>
                                <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                              layout="vertical">
                                    <Descriptions.Item label="شماره درخواست">
                                        {this.props.initialValues ? this.props.initialValues.order.system_code : ''}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="نوع خدمت">{orderType}</Descriptions.Item>
                                    <Descriptions.Item label={`تاریخ:${date}`}>{`ساعت:${time}`}</Descriptions.Item>
                                </Descriptions>

                                <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                              layout="vertical">
                                    <Descriptions.Item label={fullName}>
                                        {this.props.initialValues ? this.props.initialValues.order.customer_by.mobile : ''}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">جزییات فاکتور</Divider>

                                {this.props.initialValues && this.props.initialValues.order.invoice.products.length > 0 && this.props.initialValues.order.invoice.products.map((item, index) => {
                                    return(
                                        <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                                      layout="vertical" title={item.title} key={index}>
                                            <Descriptions.Item label="تعداد">
                                                {item.count}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="قیمت واحد">{item.price.toLocaleString(navigator.language, {minimumFractionDigits: 0})} ريال</Descriptions.Item>
                                            <Descriptions.Item label="جمع">{(item.price*item.count).toLocaleString(navigator.language, {minimumFractionDigits: 0})}ريال</Descriptions.Item>
                                        </Descriptions>
                                    )
                                })}
                                {this.props.initialValues && this.props.initialValues.order.invoice.services.length > 0 && this.props.initialValues.order.invoice.services.map((item, index) => {
                                    return(
                                        <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                                      layout="vertical" title={item.title} key={index}>
                                            <Descriptions.Item label="تعداد">
                                                {item.count}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="قیمت واحد">{item.price.toLocaleString(navigator.language, {minimumFractionDigits: 0})} ريال</Descriptions.Item>
                                            <Descriptions.Item label="جمع">{(item.price*item.count).toLocaleString(navigator.language, {minimumFractionDigits: 0})}ريال</Descriptions.Item>
                                        </Descriptions>
                                    )
                                })}

                                <RTLCol style={{background:'#ccc',borderRadius:10,padding:10,marginBottom:20}}>
                                    <RTLCol className={'right'}>
                                        ایاب و ذهاب شهر {this.props.initialValues && this.props.initialValues.order.invoice ?
                                        this.props.initialValues.order.invoice.commuting.title :
                                        ''}
                                    </RTLCol>
                                    <RTLCol className={'left'}>
                                        {this.props.initialValues && this.props.initialValues.order.invoice ?
                                            this.props.initialValues.order.invoice.commuting.commuting_fee.toLocaleString(navigator.language, {minimumFractionDigits: 0}) :
                                            ''}
                                        ريال
                                    </RTLCol>
                                    <RTLCol className={'clearfix'}></RTLCol>
                                </RTLCol>

                                <RTLCol style={{border:'1px solid #ccc',padding:10,marginBottom:20}}>
                                    <RTLCol className={'right'}>
                                        مبلغ تخفیفات و هدیه
                                    </RTLCol>
                                    <RTLCol className={'left'}>
                                        {this.props.initialValues && this.props.initialValues.order.invoice ?
                                            this.props.initialValues.order.invoice.discounts.toLocaleString(navigator.language, {minimumFractionDigits: 0}) :
                                            ''}
                                        ريال
                                    </RTLCol>
                                    <RTLCol className={'clearfix'}></RTLCol>
                                </RTLCol>
                                <RTLCol style={{border:'1px solid #ccc',padding:10,marginBottom:20}}>
                                    <RTLCol className={'right'}>
                                        مبلغ فاکتور
                                    </RTLCol>
                                    <RTLCol className={'left'}>
                                        {this.props.initialValues && this.props.initialValues.order.invoice ?
                                            this.props.initialValues.order.invoice.final_price.toLocaleString(navigator.language, {minimumFractionDigits: 0}) :
                                            ''}
                                        ريال
                                    </RTLCol>
                                    <RTLCol className={'clearfix'}></RTLCol>
                                </RTLCol>

                                <RTLCol className={'yellowBox'} style={{color:'#fff',padding:10,marginBottom:20}}>
                                    <RTLCol className={'right'}>
                                        مبلغ قابل پرداخت
                                    </RTLCol>
                                    <RTLCol className={'left'}>
                                        {this.props.initialValues && this.props.initialValues.order.invoice ?
                                            this.props.initialValues.order.invoice.price_to_payment.toLocaleString(navigator.language, {minimumFractionDigits: 0}) :
                                            ''}
                                        ريال
                                    </RTLCol>
                                    <RTLCol className={'clearfix'}></RTLCol>
                                </RTLCol>

                                <Divider orientation="left">نوع پرداخت</Divider>

                                <Field
                                    name="cash"
                                    component={TextField}
                                    type="text"
                                    placeholder="نقدی (ریال)"
                                    onChange={(val) => this.setState({
                                                cash: val.target.value ? parseInt(val.target.value) : 0,
                                            }
                                        )
                                    }
                                />

                                <Field
                                    name="pos"
                                    component={TextField}
                                    type="text"
                                    placeholder="کارتخوان (ریال)"
                                    onChange={
                                        (val) => this.setState({
                                                pos: val.target.value ? parseInt(val.target.value) : 0,
                                            }
                                        )
                                    }
                                />
                                {chequeField}

                            </Row>
                            <Row>
                                <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button"
                                   disabled = {totalAmount === this.props.initialValues.order.invoice.price_to_payment ? false : true}
                                >
                                    پرداخت
                                </RTLButton>
                                <RTLButton href="#/order/list" className="backBtn" type="default" shape="round">
                                    بازگشت
                                </RTLButton>
                            </Row>
                        </RTLCol>
                    </Row>
                :
                    <Loading list={this.props.initialValues}/>
                }
            </Form>

        );
    }

}

export default TechForm = reduxForm({
    form: 'order',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(TechForm)
